import React from "react";

import { Box, Card, Stack, styled, Typography } from '@material-ui/core';

import { MessageData, MessageGiphyData, MessagePhotoData, MessageTranslatedData, MessageVoiceData, MesssageStickerData } from "../../types";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";



const MsgPhoto = styled('img')({
  borderRadius: '10px',
  width: 300,
  cursor: 'zoom-in',
});



interface MsgProps {
  message: MessageData;
}

export const MessageItem: React.FC<MsgProps> = ({ message }) => {


  const right = message.fromUserId === message.users[ 1 ];

  const renderContent = () => {
    if (message.type === 'photo') {
      const data = message.data as MessagePhotoData;
      return (
        <a href={`${process.env.REACT_APP_CDN_URL}/${data.path}`} target="_blank" rel="noreferrer">
          <MsgPhoto src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} />
        </a>
      )
    }

    if (message.type === 'sticker') {
      const data = message.data as MesssageStickerData;
      return <img src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} alt={message.id} width={50} />
    }

    if (message.type === 'giphy') {
      const data = message.data as MessageGiphyData;
      return <img src={data.url} alt={message.id} width={200} />
    }

    if (message.type === 'translated') {
      const data = message.data as MessageTranslatedData;
      return <Typography>{data.en}</Typography>
    }

    if (message.type === 'voice') {
      const data = message.data as MessageVoiceData;
      return (
        <audio controls>
          <source src={`${process.env.REACT_APP_CDN_URL}/${data.path}`} type="audio/mp4" />
        </audio>
      );
    }


    return (

      <Box sx={{
        backgroundColor: '#eee',
        p: 1,
        borderRadius: '10px',
        borderTopRightRadius: right ? 0 : '10px',
        borderTopLeftRadius: !right ? 0 : '10px',
      }}>
        <Typography>{message.data}</Typography>
      </Box>

    );
  }



  return (
    <Stack direction="column" alignItems={right ? 'flex-end' : 'flex-start'}>
      <Stack direction="row" spacing={1}>
        {right ? null : <ProfileAvatar userId={message.fromUserId} size={25} />}
        {
          renderContent()
        }
        {!right ? null : <ProfileAvatar userId={message.fromUserId} size={25} />}
      </Stack>
      <Typography variant="caption">
        {timeAgo(message.createTime.toDate())}
      </Typography>
    </Stack>
  )
}

interface Props {
  messages: MessageData[]
}

const MessageList: React.FC<Props> = ({ messages }) => {

  return (
    <Card variant="outlined" sx={{
      mt: 2,
      p: 2,
      flex: 1,
      width: '100%',
      maxWidth: 800,
      alignSelf: 'center',
    }}>
      <Stack direction="column" spacing={1}>
        {
          messages.map(message => <MessageItem message={message} key={message.id} />)
        }
      </Stack>
    </Card >
  );
};

export default MessageList;